// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1RXHk","clinicsSelect":"TableHeading_clinicsSelect__1-jLo"};